export const furanosePentose = `
Actelion Java MolfileCreator 1.0

  7  7  0  0  0  0  0  0  0  0999 V2000
   17.6752  -13.3126    0.0000 C   0  0  0  0  0  0  0  0  0  1  0  0
   17.6752  -14.8126    0.0000 C   0  0  0  0  0  0  0  0  0  2  0  0
   19.1017  -15.2761    0.0000 C   0  0  0  0  0  0  0  0  0  3  0  0
   19.9834  -14.0626    0.0000 C   0  0  0  0  0  0  0  0  0  4  0  0
   19.1017  -12.8490    0.0000 O   0  0  0  0  0  0  0  0  0  5  0  0
   21.4834  -14.0626    0.0000 O   0  0  0  0  0  0  0  0  0  6  0  0
   16.4616  -12.4309    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  1  1  0  0  0  0
  4  6  1  0  0  0  0
  1  7  1  0  0  0  0
M  STY  1   1 DAT
M  SLB  1   1   1
M  SAL   1  1   1
M  SDT   1 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   1    17.6752   13.3126    DA    ALL  1       5
M  SED   1 4
M  STY  1   2 DAT
M  SLB  1   2   2
M  SAL   2  1   2
M  SDT   2 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   2    17.6752   14.8126    DA    ALL  1       5
M  SED   2 3
M  STY  1   3 DAT
M  SLB  1   3   3
M  SAL   3  1   3
M  SDT   3 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   3    19.1017   15.2761    DA    ALL  1       5
M  SED   3 2
M  STY  1   4 DAT
M  SLB  1   4   4
M  SAL   4  1   4
M  SDT   4 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   4    19.9834   14.0626    DA    ALL  1       5
M  SED   4 1
M  STY  1   5 DAT
M  SLB  1   5   5
M  SAL   5  1   7
M  SDT   5 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   5    16.4616   12.4309    DA    ALL  1       5
M  SED   5 5
M  END
`;
//# sourceMappingURL=furanosePentose.js.map